import { clsx } from 'clsx';
import * as styles from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import { TDoor } from 'shared/types/doors';

interface IDoorProps extends Omit<TDoor, 'title' | 'onClickBtn'> {
  date: string;
  device: TDeviceType;
  doorIsDisabled: boolean;
  completed: boolean;
  onModalContent: VoidFunction;
}

export const Door: React.FC<IDoorProps> = ({ date, image, device, doorIsDisabled, completed, onModalContent }) => {
  return (
    <div
      className={clsx(
        styles['item'],
        styles[device],
        doorIsDisabled && styles['disabled'],
        completed && styles['door-completed'],
      )}
      onClick={doorIsDisabled ? undefined : onModalContent}
    >
      {completed ? (
        <div className={styles['completed']} />
      ) : (
        <>
          <div className={styles['title']}>{`${date} декабря`}</div>
          <div className={clsx(styles['image'], styles[image])} />
        </>
      )}
    </div>
  );
};
